import { Box, Grid, Typography } from "@mui/material";
import inventoryPaymentSetupSectionStyles from "./inventoryPaymentSetupSection.styles";
import inventoryAndPaymentSetup from "../../../assets/images/inventoryAndPaymentSetup.webp";
import { INVENTORY_PAYMENT_SETUP } from "../../../constants/lang";

const InventoryPaymentSetupSection = ({isCustomerSupport}) => {
    const styles = inventoryPaymentSetupSectionStyles;
    const steps = INVENTORY_PAYMENT_SETUP;
    
    return (
        <Box
            sx={{
                ...styles.container,
                pt: isCustomerSupport ? "10px" : { xs: "20px", sm: "30px", md: "40px", lg: "51.54px" },
                pb: isCustomerSupport ? "10px" : { xs: "33.06px", sm: "30px", md: "40px", lg: "87.27px" }
            }}
        >
            <Grid container spacing={2}>
                <Grid item xs={12} md={6.1786} sx={{ textAlign: { xs: "center", md: "left" }}}>
                    <Box component="img" sx={styles.image} src={inventoryAndPaymentSetup} alt="inventoryAndPaymentSetup" />
                </Grid>
                <Grid item xs={12} md={5.8214}>
                    <Box sx={styles.headerContainer}>
                        <Typography sx={styles.headerText}>Inventory and Payment Setup</Typography>
                        <Box sx={styles.headerLine} />
                        <Typography sx={styles.headerDescription}>
                            Simplify your Wanderobe store front. Effortlessly manage your products and payments in just a few steps.
                        </Typography>
                    </Box>
                    
                    <Grid container sx={styles.stepsContainer} rowSpacing={{ xs: 3.87, md: 5, lg:12.25}} columnSpacing={{ xs: 3.5, md: 2, lg: 4}}>
                        {steps?.map((step, index) => (
                            <Grid item xs={6} key={index} sx={styles.stepItem}>
                                <Box sx={styles.stepNumber}>{step.step}</Box>
                                <Box sx={styles.stepContent}>
                                    <Typography sx={styles.stepTitle}>{step.title}</Typography>
                                    <Typography sx={styles.stepDescription}>{step.description}</Typography>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    )
}

export default InventoryPaymentSetupSection;